export default "__VITE_ASSET__nmGzhgPR__";